import React, { useRef, useState } from 'react';

import '../styles/gallery.css';


import garden1 from '../assets/images/hall_3.webp';
import garden2 from '../assets/images/hall_4.webp';
import garden3 from '../assets/images/hall_2.webp';
import crowd from '../assets/images/Conf-1.webp';
import wedding from '../assets/images/Conf-2.webp';

const images = [garden1, garden2, garden3, crowd, wedding];

const GardenGallery = ({ language }) => {
  const scrollRef = useRef(null);
  const [modalImage, setModalImage] = useState(null);

  const scroll = (dir) => {
    scrollRef.current.scrollBy({ left: dir === 'left' ? -400 : 400, behavior: 'smooth' });
  };

  return (
    <section className="gallery-wrapper py-5 bg-dark text-white">
      <div className="container">
<h2 className="fw-bold mb-4 text-center">
  {language === 'en' ? 'Conference Hall Gallery' : 'የኮንፈረንስ አዳራሽ ጋለሪ'}
</h2>
        <div className="gallery-scroll-wrapper">
          <button className="scroll-btn left" onClick={() => scroll('left')}>&lt;</button>
          <div className="gallery-scroll" ref={scrollRef}>
            {images.map((img, i) => (
              <div className="gallery-image-wrapper" key={i} onClick={() => setModalImage(img)}>
                <img src={img} className="gallery-image" alt={`garden-${i}`} />
              </div>
            ))}
          </div>
          <button className="scroll-btn right" onClick={() => scroll('right')}>&gt;</button>
        </div>
      </div>

      {modalImage && (
        <div className="image-modal" onClick={() => setModalImage(null)}>
          <img src={modalImage} className="modal-img" alt="preview" />
          <button className="close-btn" onClick={() => setModalImage(null)}>×</button>
        </div>
      )}
    </section>
  );
};

export default GardenGallery;
